import React from "react";
import "./SelectedForm.css";
import { MdEditNote } from "react-icons/md";
import { FaDeleteLeft } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useFormContext } from "../../context/FormContext";
import BASE_URL from "../../../config";

const SelectedKanban = ({ sltdForm, handleKanbanRemove }) => {
  const {
    newFormId,
    setNewFormId,
    setFormData,
    setIsKanbanBuilder,
    setBuilderType,
    setKanbanDetail,
  } = useFormContext();
  const navigate = useNavigate();

  // method for clicking on edit button
  const handleEdit = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/form/forms/fetch/kanban?form_id=${newFormId}`
      );
      const data = await response.json();
      if (response.ok) {
        setKanbanDetail(data.kanban_data);
        // setIsKanbanBuilder(true);
        setBuilderType("kanban");
        setFormData(sltdForm.formbuilder_data);
        setNewFormId(sltdForm.form_builder_id);
        navigate("/form-builder");
      } else {
        console.log("error in editing kanban data: ", data);
        // setIsKanbanBuilder(true);
        setBuilderType("kanban");
        setFormData(sltdForm.formbuilder_data);
        navigate("/form-builder");
      }
    } catch (err) {
      console.error("error: ", err);
    }
  };
  return (
    <div className="selectedForm">
      {sltdForm !== "" && (
        <>
          <span>{sltdForm.form_builder_name}'s Kanban View</span>
          <div className="selectedFormBtns">
            <button className="btn btn-secondary" onClick={handleEdit}>
              <MdEditNote style={{ fontSize: "25px" }} />
            </button>
            <button className="btn btn-danger" onClick={handleKanbanRemove}>
              <FaDeleteLeft style={{ fontSize: "20px" }} />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default SelectedKanban;
